import { Reveal, Eyebrow } from "@/components/Reveal";

const CHAPTERS = [
  {
    number: "01",
    title: "Direct Farm & Mill Sourcing",
    text: "We handpick pulses, grains, and daily essentials straight from trusted regional producers for unbeatable freshness and zero adulteration.",
  },
  {
    number: "02",
    title: "Purity & Quality Hand-Check",
    text: "Every packet of flour, batch of spices, and container of oil undergoes strict quality inspection before landing on our shelves.",
  },
  {
    number: "03",
    title: "Heart of the Neighbourhood",
    text: "For over two decades, Shivam Kirana has been the reliable daily lifeline for local families in our community.",
  },
  {
    number: "04",
    title: "Doorstep Local Delivery",
    text: "Fast, friendly phone or online enquiry ordering with free same-day neighbourhood doorstep delivery.",
  },
];

export default function Manifesto() {
  return (
    <section className="bg-bone py-20 lg:py-28" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>The Shivam Way</Eyebrow>
          <h2 className="mt-4 font-serif font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-ink max-w-2xl">
            Four promises we have kept,
            <span className="italic text-forest"> every single day</span> since 2002.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-x-12">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.number} delay={i * 0.08}>
              <div className="group border-t border-line py-8 flex gap-6 sm:gap-8 items-start">
                <span className="font-serif italic font-bold text-4xl sm:text-5xl text-marigold/70 group-hover:text-marigold transition-colors duration-500 leading-none">
                  {c.number}
                </span>
                <div>
                  <h3 className="font-serif font-semibold text-xl sm:text-2xl text-ink group-hover:text-forest transition-colors duration-300">
                    {c.title}
                  </h3>
                  <p className="mt-3 text-sm sm:text-base text-ink-soft leading-relaxed">{c.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
